<app-entity-page
[closeClicked]="closeClicked"
[detailsContentTitle]="getDetailsTitle()"
  [mapContentTitle]="'iaa.general.map' | translate" [loading]="locusDetailsIsLoading">
  <ng-template #detailsContent>
    <div class="locus-content" >
      <div class="locus-content-body">
        <locus-details  class="locus-details" [selectedLocus]="selectedLocusDetails" [currentLanguage]="currentLanguage$"></locus-details>
        <div class="baskets-container">
          <details class="baskets-details" #details [open]="!!locusBasketList?.length" [autofocus]="false">
            <summary>
              <div class="baskets-summary">
                <div class="baskets-title">  {{'iaa.app.locus.basketsInLocus' | translate}} ({{basketGroups[0]?.baskets?.length || 0 }}) 
                </div>
                <div class="icons">
                  <i [ngClass]="{'pi pi-angle-left icon-default':true, 'en': (currentLanguage$| async) === 'en'}"></i>
                  <i class="pi pi-angle-down icon-clicked"></i>
                </div>
              </div>
              <span class="sr-only">{{'iaa.app.locus.selectBasket' | translate}}</span>
            </summary>
            <div class="basket-container" *ngIf="!!basketGroups?.length">
              <locus-basket-groups class="basket-groups" [basketGroups]="basketGroups"
                (selected)="groupSelected($event)"></locus-basket-groups>
              <locus-basket-list class="basket-list" [locusBasketList]="locusBasketList"
                [selectedBasketId]="entityId" [currentLanguage]="currentLanguage$"></locus-basket-list>
            </div>
          </details>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #mapContent>
    <div class="map-container">
    <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls"></app-arcgis-map>
    </div>
  </ng-template>
</app-entity-page>